import { FC, useEffect, useState } from "react"
import { Link } from "react-router-dom";

import StepperModal from "../stepperModal";

import { CaseDetailPropsType, QueryParamsState } from "./types";
import { objectToQueryString } from "src/helpers";
import { CASE_DETAIL_HEADER, CASE_DETAIL_HEADER_DOC_STATS } from "src/constants/manufacturer";

import CaseDetailButtonUpdate from "./caseDetailButtonUpdate";
import TreatedOrNotTreatedTreatment from "src/components/modals/treatedOrNotTreatedTreatment";
import CancelTreatment from "src/components/modals/cancelTreatment";
import RequestDateOfTreatment from "src/components/modals/requestDateOfTreatment";
import { TreatmentListErrorResponse, TreatmentStatusUpdateApiResponse } from "src/pages/treatmentListing/types";
import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";



const CaseDetail: FC<CaseDetailPropsType> = ({ baseUrl, searchParams, CaseDetailListType ,forPage, refreshListing }): JSX.Element => {
  const [showingModal, setModal] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [caseDetails, setCaseDetails] = useState<any>(null);
  const [showRequestTreatmentModal, setDataForRequestModalTreatment] = useState<{ isModalVisible: boolean; caseId: number; prescriptionId :number ,buttonFor:string}>({
    isModalVisible: false,
    caseId: 0,
    prescriptionId:0,
    buttonFor:""
  });
  const [cancelTreatmentModal, setDataForCancelModal] = useState<{ isModalVisible: boolean; caseId: number; prescriptionId :number }>({
    isModalVisible: false,
    caseId: 0,
    prescriptionId:0
  });
  const [treatedOrNotTreatedTreatmentModal, setDataForTreatedOrNotTreatedTreatmentModal] = useState<{ isModalVisible: boolean,caseId:number,treatment_id:number}>({
    isModalVisible: false,
    caseId : 0,
    treatment_id: 0
  });





  const [queryParams, updateQueryParams] = useState<QueryParamsState>({
    direction: "desc",
    sort_by: "case_id",
  });

  const openModal = (caseItem: any) => {
    setModal(true);
    setCaseDetails(caseItem);
  };
  const { data: treatmentUpdateData, mutate: updatetreatment, error: treatmentUpdateError } =
  useFetch<TreatmentStatusUpdateApiResponse>(APIEndpoints.TREATMENT_STATUS_UPDATE);

useEffect(() => {
  if (treatmentUpdateError) {
   // hideLoader();
    const { code } = treatmentUpdateError as unknown as TreatmentListErrorResponse;
    //showToast([error || `Treatment can't update now. Please try again in a while.`], ToastTypes.ERROR);
    if (code === 401) {
      // destroySession();
      // navigate(`/users/sign_in`);
    }
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [treatmentUpdateError]);

useEffect(() => {
  const hasUpdateData = treatmentUpdateData?.code;

  if (hasUpdateData || treatmentUpdateError) {
    if (hasUpdateData) {
      // getCaseListing(null, null, initialState);
    }
    // hideLoader();
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [treatmentUpdateError, treatmentUpdateData]);

  const onTreatedOrNotTreatedButtonClicked = (value: string, treatment_id: number) => {
    const requestBody = { status: 0 };

    if (value === "Not-Treated") {
      requestBody.status = 31;
    } else {
      requestBody.status = 22;
    }
    // setLoader()
    updatetreatment(requestBody, { treatmentId: treatment_id });
  };


  const changeIdOrder = (tableHeader: string) => {
    const updatedQueryParams: QueryParamsState = {
      sort_by: tableHeader,
      direction: tableHeader === queryParams.sort_by ? (queryParams.direction === "desc" ? "asc" : "desc") : "desc"
    };

    switch (updatedQueryParams.sort_by) {
      case "case_id":
        CaseDetailListType.sort((item1, item2) => {
          if (updatedQueryParams.direction === "asc")
            return Number(item1.case_id) - Number(item2.case_id);
          else
            return Number(item2.case_id) - Number(item1.case_id);
        });
        break;

      case "patient_id":
        CaseDetailListType.sort((item1, item2) => {
          if (updatedQueryParams.direction === "asc")
            return Number(item1.patient_id) - Number(item2.patient_id);
          else
            return Number(item2.patient_id) - Number(item1.patient_id);
        });
        break;
      case "received":
        CaseDetailListType.sort((item1, item2) => {
          if (updatedQueryParams.direction === "asc")
            return (item1.received || "").localeCompare(item2.received || "");
          else
            return (item2.received || "").localeCompare(item1.received || "");
        });
        break;

      case "completed":
        CaseDetailListType.sort((item1, item2) => {
          if (updatedQueryParams.direction === "asc")
            return (item1.completed || "").localeCompare(item2.completed || "");
          else
            return (item2.completed || "").localeCompare(item1.completed || "");
        });
        break;
      case "payer":
        CaseDetailListType.sort((item1, item2) => {
          if (updatedQueryParams.direction === "asc")
            return (item1.payer || "").localeCompare(item2.payer || "");
          else
            return (item2.payer || "").localeCompare(item1.payer || "");
        });
        break;
      case "case_status":
        CaseDetailListType.sort((item1, item2) => {
          if (updatedQueryParams.direction === "asc")
            return (item1.case_status || "").localeCompare(item2.case_status || "");
          else
            return (item2.case_status || "").localeCompare(item1.case_status || "");
        });
        break;
      case "provider.doc_name":
        CaseDetailListType.sort((item1, item2) => {
          if (updatedQueryParams.direction === "asc")
            return item1.provider.doc_name.localeCompare(item2.provider.doc_name);
          else
            return item2.provider.doc_name.localeCompare(item1.provider.doc_name);
        });
        break;
    }

    updateQueryParams(updatedQueryParams);
  };

  return (
    <>
      <div className="card">
        <div className="card-header">
          <h4 className="heading-title text-center">Case Details</h4>
        </div>

        <div className="card-body p-0">
          <div className="table-responsive overflow-auto" style={{ minHeight: "50px", maxHeight: "350px" }}>
            {forPage === 'TERRITORY' ? 
            <table className="table table-sm mb-0">
              <thead className="thead-sticky">
                <tr>
                  {CASE_DETAIL_HEADER.map((tableHeader, index) => (
                    <th
                      key={index}
                      className="text-center"
                      scope="col"
                      onClick={tableHeader.value !== '' ? () => changeIdOrder(tableHeader.value) : undefined}
                    >
                      <span
                        role={tableHeader.value === '' ? "textbox" : "button"}
                        className={
                          tableHeader.value === '' ?
                            'fw-bold fs-6 lh-base' :
                            'btn btn-link link-primary link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover p-0 fw-bold'
                        }
                      >
                        {tableHeader.label}
                        {queryParams.sort_by === tableHeader.value ? (
                          <i className={`bi ${queryParams.direction === 'desc' ? 'bi-caret-up-fill' : 'bi-caret-down-fill'}`}></i>
                        ) : null}
                      </span>
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody className="table-group-divider">
                {CaseDetailListType &&
                  CaseDetailListType.map((item, index) => (
                    <tr key={index} className="align-middle">
                      <td className="text-center">
                        <button
                          className="btn btn-primary btn-case rounded-0"
                          onClick={() => openModal(item)}
                        >
                          {item?.case_id}
                        </button>
                      </td>
                      <td className="text-center">
                        <Link
                          to={{
                            pathname: baseUrl,
                            search: objectToQueryString(baseUrl === "/territories" ? {
                              search_str: item.patient_id,
                              type:"territories",
                              id: searchParams.id,
                              start_date:searchParams.start_date,
                              end_date : searchParams.end_date,
                              detail: true,
                              str:item.patient_id
                            } : {
                              id: searchParams.id,
                              filter_type: searchParams.filter_type,
                              role: searchParams.role,
                              period: searchParams.period,
                              global_patient_external_id: item.patient_id,
                              detail: true,
                              str:item.patient_id
                            }),
                          }}
                          // target="_blank"
                          reloadDocument
                          className="link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover"
                        >
                          {item?.patient_id}
                        </Link>
                      </td>
                      <td className="text-center">{item?.qty}</td>
                      <td className='text-center'>{item.received}</td>
                      <td className="text-center">{item?.completed}</td>
                      <td className="text-center">{item?.payer}</td>
                      <td className="text-center">{item?.med_cvge}</td>
                      <td className="text-center">{item?.med_pa.data}</td>
                      <td className={`text-center align-middle text-white background-color-${item && item.color_idx ? item.color_idx : 1}`}
                        style={{ minWidth: "200px" }}>
                        {item.case_status}
                      </td>
                      <td className="text-center">
                        <CaseDetailButtonUpdate
                                kase={item}
                                showHideModalForTreatment={setDataForRequestModalTreatment}
                                setDataForCancelModal={setDataForCancelModal}
                                onTreatedOrNotTreatedButtonClicked={onTreatedOrNotTreatedButtonClicked}
                                setDataForTreatedOrNotTreatedTreatmentModal={setDataForTreatedOrNotTreatedTreatmentModal}
                            />
                      </td>
                      <td className="text-center">
                         {item?.provider.doc_name}
                      </td>

                    </tr>
                  ))
                }
              </tbody>
            </table> : <table className="table table-sm mb-0">
              <thead className="thead-sticky">
                <tr>
                  {CASE_DETAIL_HEADER_DOC_STATS.map((tableHeader, index) => (
                    <th
                      key={index}
                      className="text-center"
                      scope="col"
                      onClick={tableHeader.value !== '' ? () => changeIdOrder(tableHeader.value) : undefined}
                    >
                      <span
                        role={tableHeader.value === '' ? "textbox" : "button"}
                        className={
                          tableHeader.value === '' ?
                            'fw-bold fs-6 lh-base' :
                            'btn btn-link link-primary link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover p-0 fw-bold'
                        }
                      >
                        {tableHeader.label}
                        {queryParams.sort_by === tableHeader.value ? (
                          <i className={`bi ${queryParams.direction === 'desc' ? 'bi-caret-up-fill' : 'bi-caret-down-fill'}`}></i>
                        ) : null}
                      </span>
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody className="table-group-divider">
                {CaseDetailListType &&
                  CaseDetailListType.map((item, index) => (
                    <tr key={index} className="align-middle">
                      <td className="text-center">
                        <button
                            className="btn btn-primary btn-case rounded-0"
                            onClick={() => openModal(item)}
                        >
                          {item?.case_id}
                        </button>
                      </td>
                      <td className="text-center">{item?.qty}</td>
                      <td className='text-center'>{item.received}</td>
                      <td className="text-center">{item?.completed}</td>
                      <td className="text-center">{item?.payer}</td>
                      <td className="text-center">{item?.outcome}</td>
                      <td className="text-center">{item?.rx_cvge}</td>
                      <td className="text-center">{item?.med_cvge}</td>
                      <td className="text-center">{item?.rx_pa.data}</td>
                      <td className="text-center">{item?.med_pa.data}</td>
                      <td className={`text-center align-middle text-white background-color-${item && item.color_idx ? item.color_idx : 1}`}
                        style={{ minWidth: "200px" }}>
                        {item.case_status}
                      </td>
                      <td className="text-center">{item?.network}</td>
                      <td className="text-center">
                         {item?.provider.doc_name}
                      </td>

                    </tr>
                  ))
                }
              </tbody>
            </table>}

          </div>
        </div>
      </div>

      <div className="col-8">
        {showingModal ? (
            <StepperModal
                onClick={() => {
                  setModal(false);
                  setCaseDetails(null);
                }}
                caseId={caseDetails.case_id}
            />
        ) : null}
      </div>
      <RequestDateOfTreatment
            isModalVisible={showRequestTreatmentModal.isModalVisible}
            caseId={showRequestTreatmentModal.caseId}
            prescriptionId={showRequestTreatmentModal.prescriptionId}
            buttonFor={showRequestTreatmentModal.buttonFor}
            hideModal={() => {
              setDataForRequestModalTreatment({
                isModalVisible: false,
                caseId: 0,
                prescriptionId: 0,
                buttonFor:""
              });
            }}
            refreshListing={refreshListing}
        />

        <CancelTreatment
            isModalVisible={cancelTreatmentModal.isModalVisible}
            caseId={cancelTreatmentModal.caseId}
            prescriptionId={cancelTreatmentModal.prescriptionId}
            buttonFor=""
            hideModal={() => {
              setDataForCancelModal({
                isModalVisible: false,
                caseId: 0,
                prescriptionId: 0
              });
            }}
            refreshListing={refreshListing}
        />

        <TreatedOrNotTreatedTreatment
            isModalVisible={treatedOrNotTreatedTreatmentModal.isModalVisible}
            dataTreatmentStates={treatedOrNotTreatedTreatmentModal}
            onTreatedOrNotTreatedButtonClick={onTreatedOrNotTreatedButtonClicked}
            hideModal={() => {
              setDataForTreatedOrNotTreatedTreatmentModal({
                isModalVisible: false,
                caseId: 0,
                treatment_id:0
              });
            }}
            refreshListing={refreshListing}
        />
     </>
  );
};

export default CaseDetail;
